export function getRandomSubarray(arr, size) {
    const shuffled = arr.slice(0);
    let i = arr.length;
    let temp;
    let index;
    while (i--) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
    }
    return shuffled.slice(0, size);
}
export function sortAlphabetically(a, b) {
    if (a < b)
        return -1;
    if (a > b)
        return 1;
    return 0;
}
//# sourceMappingURL=index.js.map